module.exports = __webpack_public_path__ + "img/personal-details-active.b3cc549a.svg";